import React from "react";
import { Card } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import MenuSyncSettings from "../MenuSyncSettings";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import AutoSyncSwitch from "./PosSyncs/AutoSyncSwitch";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function Boomi() {
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <MenuSyncSettings />
          <AutoSyncSwitch />

          <FormSwitchTC
            name={"apiaccounts__useTest"}
            tDefault={"Gebruik test omgeving"}
            tKey={"vestigingen.form.apiaccounts.label.useTest"}
          />
          <FormTextTC
            name={"apiaccounts__basic_auth_username"}
            tDefault={"Basic auth username"}
            tKey={"Basic auth username"}
          />
          <FormTextTC
            name={"apiaccounts__basic_auth_password"}
            tDefault={"Basic auth password"}
            tKey={"Basic auth password"}
          />
          <FormTextTC name={"custom_data.boomi.channel_id"} tDefault={"Channel ID"} tKey={"Channel ID"} />
          <FormTextTC name={"custom_data.boomi.shop_id"} tDefault={"Shop ID"} tKey={"Shop ID"} />
          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"campaign_discount_product-" + menukaartVestigingId}
            name={"custom_data.boomi.campaign_discount_product"}
            tDefault={"Campaign discount product"}
            tKey={"custom_data.boomi.campaign_discount_product"}
          />

          <FormSwitchTC name={"extra_settings__printProductQR"} tDefault={"Print order QR"} tKey={"Print order QR"} />
        </CardBody>
      </Card>
    </div>
  );
}

export default Boomi;
